export interface AppConfig {
  FILES_MIGRATED: boolean
  environment: string
  api: {
    baseUrl: string
    wsUrl: string
    header: string
  }
  auth: {
    auth0: {
      audience: string
      clientId: string
      domain: string
      returnTo: string
    }
    cognito: {
      region: string
      userPoolId: string
      userPoolClientId: string
      domain: string
      issuer: string
    }
  }
  algolia: {
    applicationId: string
    searchApiKey: string
    searchEnable: boolean
  }
  bugsnag: {
    apiKey: string
    enabled: boolean
  }
  filestack: {
    apiKey: string
    maxFileSize: number
  }
  pag: {
    awsApiUrl: string
    serverUrl: string
    graphqlUrl: string
  }
  plus: {
    apiUrl: string
    wsUrl: string
  }
  storage: {
    s3Bucket: string
  }
  tableau: {
    url: string
  }
  features: Record<string, boolean>
}

let _config: AppConfig | null = null

export function setConfig(config: AppConfig): void {
  _config = config
}

export function getConfig(): AppConfig {
  if (!_config) throw new Error('App config not loaded. Ensure bootstrap() completed before use.')
  return _config
}
